let productItems = document.querySelectorAll('.product-grid .grid__item');

const initSwatches = productItem => {
    const colorInputs = productItem.querySelectorAll('.card__information-variants input[type="radio"]');

    colorInputs.forEach(input => {
        input.addEventListener('change', ({ target }) => {
            const selectedSwatchValue = productItem.querySelector(`[data-selected-swatch-value="${target.name}"]`);
            if (selectedSwatchValue) {
                selectedSwatchValue.textContent = target.value;
            }

            const cta = productItem.querySelector('[data-variant-cta]');
            productItem.querySelectorAll('[data-variant-price]').forEach(price => {
                const isSelected = price.dataset.variantPrice === target.id;
                price.hidden = !isSelected;
                if (isSelected && cta) {
                    cta.href = price.dataset.variantUrl;
                }
            });
        });
    });
};

const initCarouselLink = productItem => {
    const variants = productItem.querySelectorAll('.card__information-variants input[type="radio"]');
    if (variants.length <= 1) {
        return;
    }

    const emblaApi = productItem.querySelector('.embla')?.emblaApi;
    if (!emblaApi) {
        return;
    }

    const productLink = productItem.querySelector('.card__information a');
    const slideNodes = emblaApi.slideNodes()

    variants.forEach(variant => {
        slideNodes.forEach(slideNode => {
            if (slideNode.dataset.carouselControlId === variant.id) {
                variant.addEventListener('change', () => {
                    productLink.href = slideNode.href;
                });
            }
        });
    });
};

productItems.forEach(initSwatches);
productItems.forEach(initCarouselLink);

function resetColorSwatches() {
    productItems.forEach(productItem => {
        const defaultInput = Array.from(productItem.querySelectorAll('.card__information-variants input[type="radio"]'))
            .find(input => input.defaultChecked);
        if (!defaultInput) {
            return;
        }

        defaultInput.checked = true;

        const emblaApi = productItem.querySelector('.embla')?.emblaApi;
        if (emblaApi) {
            const slideIndex = emblaApi.slideNodes().findIndex(slideNode => slideNode.dataset.carouselControlId === defaultInput.id);
            if (slideIndex > -1) {
                emblaApi.scrollTo(slideIndex, true);
            }
        }

        defaultInput.dispatchEvent(new Event('change'));
    });
}

window.addEventListener('pageshow', resetColorSwatches);

document.addEventListener('product-grid:updated', () => {
    productItems = document.querySelectorAll('.product-grid .grid__item');
    productItems.forEach(initSwatches);
    productItems.forEach(initCarouselLink);
    resetColorSwatches();
});
